import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { initI18n } from "@/i18n/tr";

// iOS Safari/Chrome only apply :active (button press feedback) when a touch listener exists.
document.addEventListener("touchstart", () => {}, { passive: true });

// The translation dictionary must be in place before any app module evaluates, since
// module-level labels call tr() once at import time.
initI18n().then(() => import("@/App")).then(({ default: App }) => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
